import { useCallback } from 'react'

// TODO: not a good idea, to delete
export default function useOnClick(cb, preventDefault = true) {
  return useCallback(
    evt => {
      if (preventDefault) evt.preventDefault()
      cb(evt)
    },
    [cb, preventDefault]
  )
}
